export function filterSize(size) {
  if (!size) return '-'
  if (size < pow1024(1)) return size + ' B'
  if (size < pow1024(2)) return (size / pow1024(1)).toFixed(2) + ' KB'
  if (size < pow1024(3)) return (size / pow1024(2)).toFixed(2) + ' MB'
  if (size < pow1024(4)) return (size / pow1024(3)).toFixed(2) + ' GB'
  return (size / pow1024(4)).toFixed(2) + ' TB'
}

function pow1024(num) {
  return Math.pow(1024, num)
}

// 时长转换
export function durationTrans(a) {
  a = a / 1000
  var b = ''
  // var h = parseInt(a / 3600),
  //   m = parseInt((a % 3600) / 60),
  //   s = parseInt((a % 3600) % 60)
  // if (h > 0) {
  //   h = h < 10 ? '0' + h : h
  //   b += h + ':'
  // }
  // var m = parseInt((a % 60) / 60),
  //   s = parseInt((a % 60) % 60)

  var m = parseInt(a / 60),
    s = parseInt((a % 60) % 60)
  m = m < 10 ? '0' + m : m
  s = s < 10 ? '0' + s : s
  b += m + ':' + s
  return b
}
